/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-comment-textnodes */
import { Row } from '@tanstack/table-core';
import { Header } from 'src/pages/analytics/simulator/pricing-simulator/types/generic-table.model';

const getValueForRow = (
  headerMeatdata: Header[],
  depth: number,
  currentRow: { [key: string]: any }
) =>
  headerMeatdata &&
  headerMeatdata[depth] &&
  currentRow[headerMeatdata[depth].parent?.parent_field];

export default function ExpandableCell({
  value,
  row,
  onClick = null,
  columnMetadata = [],
  isExpand = true
}: {
  value: string;
  row: Row<any>;
  // eslint-disable-next-line react/require-default-props
  onClick?: () => void;
  columnMetadata: Header[];
  isExpand: boolean;
}) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const sortedHeader = columnMetadata.length
    ? columnMetadata.slice().sort((a, b) => a.parent.level - b.parent.level)
    : [];

  return (
    <div
      style={{
        paddingLeft: `${row.depth * 2}rem`,
        zIndex: 0,
        height: '100%'
      }}
      className='collapsible-cell'
    >
      {row.getCanExpand() && (
        <button
          type='button'
          {...{
            onClick: row.getToggleExpandedHandler(),
            className: 'row-expand-icon'
          }}
        >
          {isExpand &&
            (row.getIsExpanded() ? (
              <img
                style={{ height: '16px' }}
                src='/static/icons/Collapse_table.svg'
                alt='img'
              />
            ) : (
              <img
                style={{ height: '16px' }}
                src='/static/icons/Expand_table.svg'
                alt='img'
              />
            ))}
        </button>
      )}
      <span
        onClick={handleClick}
        style={{
          color: row.depth === 0 && row.getCanExpand() ? 'black' : '#525252',
          cursor: !onClick ? 'default' : 'pointer'
        }}
      >
        {columnMetadata.length
          ? getValueForRow(sortedHeader, row.depth, row.original)
          : value}
        {row.original.isIdentical ? (
          <div style={{ fontSize: '10px', color: '#ff1744' }}>
            Identical details in skus
          </div>
        ) : (
          ''
        )}
        {row.original.is_incomplete ? (
          <div style={{ fontSize: '10px', color: '#ff1744' }}>
            Incompleted details in sku
          </div>
        ) : (
          ''
        )}
      </span>
    </div>
  );
}
